<span *ngIf="listaEventos && listaEventos.length > 0" [matBadge]="listaEventos.length"  matBadgePosition="before" matBadgeOverlap="true" class="cursor"
  (click)="open()">
  <fa-icon [icon]="['fas', 'bell']" [fixedWidth]="true" size="lg">
  </fa-icon>
</span>

